import React from 'react'
import { Row, Container } from 'react-bootstrap';
import './casestudybody39.css';

import clientimg from '../images/case-study-client39.webp'
import outcome from '../images/outcome39.webp'

import sm1 from '../images/cs39so1.webp'
import sm2 from '../images/cs39so2.webp'
import sm3 from '../images/cs39so3.webp'
import sm4 from '../images/cs39so4.webp'
import sm5 from '../images/cs39so5.webp'
import sm6 from '../images/cs39so6.webp'




const Casestudybody39 = () => {

    return (
        <>
        <section className='casestudybody39-section'  >
          <Container>

            <Row className='w-100 py-md-5 py-4 clintrow'>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <h2>About</h2>
                      {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                      <div className="h1">The Client</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>The client is a regional investment leader in real estate, enhancing urban value & community well-being through sustainable projects with specialist operators under flexible, performance-driven models </p>
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={clientimg} alt="" />
                </div>
            </Row>
       
            <Row className='mt-md-5'>
              <div className='col-md-12'>
                <div className='content-box'>
                  <h2>Situation</h2>
                  {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                  <div className="h1">Overview</div>
                  <p className='anima '><span className='only-anima-underline' > **** </span></p>
                  <p>The client is developing a sports and wellness complex and needed to evaluate management agreement, standard lease, and lease + profit aharing structures. A 7-year scenario-based financial model was required to be built to assess returns and operator engagement options</p>
                </div>               
              </div>
            </Row>
          </Container>
        </section>
    
        <section className='casestudybody39-section bg-gredient-dark'>
          <Container>
            <Row>
              <div className='col-md-12'>
                  <div className='content-box'>
                    <h2>Approach &</h2>
                    {/* <div className="h1"><span className='h1 animate-underline' style={{ paddingBottom: "40px" }}>The Client</span></div> */}
                    <div className="h1">Methodology</div>
                    <p className='anima '><span className='only-anima-underline' > **** </span></p>
                    {/* <p>The next step was to put together and implement a step-by-step process for conducting the valuation:</p> */}
                    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Commercial Scenario Mapping: </h4>
                          <p>Structured three commercial models; <span style={{color:"#03A393",fontWeight:700}}> management agreement, lease, and hybrid.</span> Defined roles, incentives, and financial allocations. Aligned risk-sharing and income distribution among stakeholders</p>
                        </div>
                      </div>
    
                    <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Industry Research & Benchmarking: </h4>
                          <p>Conducted targeted <span style={{color:"#03A393",fontWeight:700}}> research on padel and reformer operations.</span> Identified key revenue and cost drivers. Benchmarked assumptions to ensure model relevance and accuracy</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>
                        <div className='text'>
                          <h4>Dynamic Scenario-Driven Financial Model:</h4>
                          <p>Developed <span style={{color:"#03A393",fontWeight:700}}> high-impact, end-to-end dynamic excel model, integrating assets, lease, capex, and financing assumptions</span> with live toggles and sensitivity controls delivering real-time NOI, cash flow, yield, and risk metrics to empower rapid, confident investment decisions and negotiation strategies</p>
                        </div>
                      </div>
    
                      <div className='list-text my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Detailed Forecasting:</h4>
                          <p>Developed <span style={{color:"#03A393",fontWeight:700}}> monthly and annual cash flow projections.</span> Incorporated ramp-up phases, seasonality, and capex absorption. Enabled separate visibility for owner and operator positions</p>
                        </div>
                      </div>

                      <div className='list-text last-child my-3'>
                        <div className='icon'>
                        <svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <circle cx="11.5" cy="11.5" r="11" fill="#03A393" stroke="white"/>
                        </svg>
                        </div>

                        <div className='text'>
                          <h4>Scenario & Sensitivity Analysis: </h4>
                          <p>Allowed real-time <span style={{color:"#03A393",fontWeight:700}}> adjustments of key inputs and assumptions, compared outcomes</span> across commercial model scenarios, and supported strategic decision-making with clear dashboards</p>
                        </div>
                      </div>                 

                                        
                      <h3 className='mt-5'>Sample Output</h3>
                      <div className='sample-output mt-3'>
                        <img src={sm1} alt=''/>
                        <img src={sm2} alt=''/>
                        <img src={sm3} alt=''/>
                        <img src={sm4} alt=''/>
                        <img src={sm5} alt=''/>
                        <img src={sm6} alt=''/>

                      </div>
                  </div>
                  
                </div>
            </Row>
          </Container>
        </section>

    
        <section className='casestudybody39-section outcome'  >
          <Container>
            <Row className='w-100 pb-5 clintrow '>
                <div className='col-md-4 relative order-1'>
                  <div className='left-box'>
                    <div className='content-box'>
                      <div className="h1">Outcome</div>
                      <p className='anima '><span className='only-anima-underline' > **** </span></p>
                      <p>Delivered a dynamic financial model & deal analysis deck that enabled the client to evaluate commercial structures for padel and reformer assets. The model provided clarity on financial outcomes, ancillary revenues, cost efficiency, supporting scalable planning and strategic decision-making</p>  
                    </div>
                  </div>
                           
                </div>
                <div className='col-md-8 right-box'>
                    <img src={outcome} alt="" />
                </div>
            </Row>
       
          </Container>
        </section>
    
        </>  
      )
    }

export default Casestudybody39
